import React, { useCallback, useEffect, useState, useRef } from 'react'
import { EditableInsuranceNumModalBody } from '../../../../components/templates/EditableInsuranceNumModalBody'
import { BasicResult, EditBasicResultKey } from '../../../../types/models/Presc'
import { useModal } from '../../../../shared'
import { localStorageWrapper } from '../../../../helpers/localStorage'

export const useInsuranceNumberEditModal = (
  prescId: string,
  basicResult: BasicResult,
  editBasicResult: (key: EditBasicResultKey) => void
) => {
  // prescIdをキーにして、prescId変更時に初期値を適用
  const [insuranceNumberState, setInsuranceNumberState] = useState<{
    prescId: string
    value: string
  }>({
    prescId: '',
    value: localStorageWrapper.getItem('allowedInsuranceNumBlank')
      ? ''
      : basicResult.id_22_insurance_patient_num.selected_option,
  })

  const insuranceNumberStr =
    prescId === insuranceNumberState.prescId
      ? insuranceNumberState.value
      : localStorageWrapper.getItem('allowedInsuranceNumBlank')
      ? ''
      : basicResult.id_22_insurance_patient_num.selected_option

  const setInsuranceNumberStr = useCallback(
    (value: string) => {
      setInsuranceNumberState({ prescId, value })
    },
    [prescId]
  )

  const closeEditableModalRef = useRef<() => void>(() => {})

  const completeEdit = useCallback(() => {
    editBasicResult({
      key: 'id_22_insurance_patient_num',
      value: insuranceNumberStr,
    })
    closeEditableModalRef.current()
  }, [editBasicResult, insuranceNumberStr])

  const {
    openModal: openEditableModal,
    closeModal: closeEditableModal,
    renderModal: renderEditableModal,
  } = useModal(
    <EditableInsuranceNumModalBody
      insuranceNumberStr={insuranceNumberStr}
      setInsuranceNumberStr={setInsuranceNumberStr}
      completeEdit={completeEdit}
      options={basicResult['id_22_insurance_patient_num']['options']}
      initialVal={basicResult['id_22_insurance_patient_num']['selected_option']}
    />,
    'right'
  )

  useEffect(() => {
    closeEditableModalRef.current = closeEditableModal
  }, [closeEditableModal])

  return { openEditableModal, renderEditableModal }
}
